/**
 * Quiet footer showing when a React Query result was last fetched.
 *
 * Pass `dataUpdatedAt` from a `useQuery()` result. Renders nothing until
 * the first fetch completes (so it doesn't flash "00:00:00" on cold loads).
 */
export interface LastUpdatedProps {
  /** Epoch ms — usually `useQuery({...}).dataUpdatedAt`. */
  dataUpdatedAt: number;
}

export function LastUpdated({ dataUpdatedAt }: LastUpdatedProps) {
  if (!dataUpdatedAt) return null;
  const formatted = new Date(dataUpdatedAt).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
  return (
    <div
      style={{
        marginTop: 12,
        color: 'var(--fg-4)',
        fontSize: 11,
        fontFamily: 'var(--font-mono)',
        textAlign: 'right',
      }}
    >
      Last loaded {formatted}
    </div>
  );
}
